import { acceptHMRUpdate, defineStore } from 'pinia';

export interface IConfirmOptions {
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  tone?: 'default' | 'danger';
}

interface IConfirmState extends Required<IConfirmOptions> {
  show: boolean;
}

const initialState: IConfirmState = {
  show: false,
  title: 'Confirmar',
  message: '',
  confirmText: 'Confirmar',
  cancelText: 'Cancelar',
  tone: 'default',
};

let resolver: ((value: boolean) => void) | null = null;

export const useConfirmStore = defineStore('confirm.store', {
  state: (): IConfirmState => ({ ...initialState }),
  actions: {
    ask(options: IConfirmOptions): Promise<boolean> {
      this.title = options.title ?? 'Confirmar';
      this.message = options.message;
      this.confirmText = options.confirmText ?? 'Confirmar';
      this.cancelText = options.cancelText ?? 'Cancelar';
      this.tone = options.tone ?? 'default';
      this.show = true;

      return new Promise<boolean>((resolve) => {
        resolver = resolve;
      });
    },
    settle(value: boolean) {
      this.show = false;
      if (resolver) {
        resolver(value);
        resolver = null;
      }
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useConfirmStore, import.meta.hot));
}
